





































































import EditionModal from "../../core/Modals/EditionModal.vue";
import { AvisDeVirementLigneApi } from "../../api/AvisDeVirementLigneApi";
import { AvisDeVirementLigne } from "../../models/AvisDeVirementLigne";
import { Contact } from "../../models/Contact";
import ContactSelect from "../../core/Forms/ContactSelect.vue";
import TextInput from "../../core/Forms/TextInput.vue";
import DateInput from "../../core/Forms/DateInput.vue";
import NumeralInput from "../../core/Forms/NumeraInput.vue";
import moment from "moment";

export default {
    name: "AvisDeVirementLigneModal",
    components: {
        EditionModal,
        ContactSelect,
        TextInput,
        DateInput,
        NumeralInput,
    },
    props: {
        // La ligne à éditer ; null ferme la modale.
        value: AvisDeVirementLigne,
    },
    data() {
        return {
            ligne: null,
            showModal: false,
            AvisDeVirementLigneApi: new AvisDeVirementLigneApi(),
            contactSelectFilters: [Contact.EType.Copropriete],
        };
    },
    computed: {
        coproprieteValue(): Contact | null {
            if (this.ligne && this.ligne.copropriete_id) {
                return new Contact({
                    id: this.ligne.copropriete_id,
                    nom: this.ligne.copropriete_nom,
                });
            }
            return null;
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal): void {
                // Copie de travail : Annuler ne doit pas laisser de
                // modifications dans la ligne affichée.
                this.ligne = newVal
                    ? new AvisDeVirementLigne(_.assign({}, newVal))
                    : null;
                this.showModal = !!newVal;
            },
        },
    },
    methods: {
        setCopropriete(contact: Contact): void {
            this.ligne.copropriete_id = contact ? contact.id : null;
            this.ligne.copropriete_nom = contact ? contact.nom : null;
        },
        setDateFacture(value: string): void {
            let date = moment(value, "DD/MM/YYYY", true);
            if (date.isValid()) {
                this.ligne.date_facture = date.format("YYYY-MM-DD");
            } else if (!value) {
                this.ligne.date_facture = null;
            }
        },
        saveLigne(): Promise<AvisDeVirementLigne> {
            var self = this;
            return self.AvisDeVirementLigneApi.save(self.ligne).then(function (
                res
            ) {
                self.$emit("ligne-saved", res);
                return res;
            });
        },
        closeModal(): void {
            this.showModal = false;
            this.$emit("input", null);
        },
    },
};
